import fetch from '@/utils/fetch'
import constants from '@/utils/constants'

// 生活统计
export function lifeRecordStatic(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.HEALTH + '/organize/web/lifeRecord/statistics',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 记录详情
export function lifeRecordInfo(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.HEALTH + '/organize/web/lifeRecord/info',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 生活记录导出
export function lifeRecordExport(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.HEALTH + '/organize/web/lifeRecord/statistics/list/export',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 午餐订餐统计
export function lunchStatic(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.HEALTH + '/organize/web/lunchOrder/barchartStatistics',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 午餐订餐导出
export function lunchExport(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.HEALTH + '/organize/web/lunchOrder/export',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 用餐订餐统计
export const lunchOrderStatic = (data:any) => fetch({
  url: constants.API_MODULE_PATH.HEALTH + '/organize/web/lunchOrder/barchartStatistics',
  method: 'post',
  data
})

// 消毒统计
export function disinfectCheckStatic(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.HEALTH + '/organize/web/inspectRecord/disinfectCheck/barchart/statistics',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 消毒导出
export function disinfectCheckExport(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.HEALTH + '/organize/web/inspectRecord/disinfectCheck/list/export',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 消毒详情
export function disinfectCheckInfo(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.HEALTH + '/organize/web/inspectRecord/info',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 出园统计
export function outCampusStatic(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.HEALTH + '/organize/web/leaveCheck/statistics',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 消出园导出
export function outCampusExport(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.HEALTH + '/organize/web/leaveCheck/statistics/list/export',
    method: 'post',
    data: {
      ...param
    }
  })
}
